import Swiper, { Navigation, Lazy, Pagination, EffectFade } from "swiper";
import GallerySimple from '../blocks/gallery-simple';
import Gallery from '../blocks/gallery';
import GalleryVideo from '../blocks/gallery-video';
import GoogleMap from '../utils/map';

const templateAbout = {
  init() {
    templateAbout.ReviewSlider();
    new GallerySimple('.gallery-simple');
    new Gallery('.gallery');
    new GalleryVideo('.gallery-video');
  },

  ReviewSlider() {
    const swiperEl = $(".review");
    if (!swiperEl.length) {
      return;
    }

    if (swiperEl.length) {
      const navPrev = swiperEl.find(".swiper-button--prev");
      const navNext = swiperEl.find(".swiper-button--next");

      new Swiper(swiperEl.find(".review__slider")[0], {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,

        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
        breakpoints: {
          500: {
            slidesPerView: "auto",
          },
          1200: {
            spaceBetween: 40,
            slidesPerView: "auto",

          }
        }
      });
    }

  },
}

export default templateAbout;
